import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const upgreatComplexItems = [
    {
        title: '01. Нет подробного техзадания',
        texts: [
            'Конкурс с&nbsp;подобным заданием проводится впервые в&nbsp;мире. Поэтому рабочей платформы, которую можно скопировать и&nbsp;адаптировать под задачи &laquo;ПРО//ЧТЕНИЕ&raquo;, не&nbsp;существовало.',
            'В&nbsp;техзадании заказчика был список задач, но&nbsp;без подробностей, как именно надо их&nbsp;решить. Таким образом, провести бизнес-анализ, разработать архитектуру платформы, отладить все процессы нам предстояло вместе с&nbsp;командой заказчика.',
        ],
    },
    {
        title: '02. Жёсткий дедлайн',
        texts: [
            'Техзадание мы&nbsp;получили в&nbsp;мае, а&nbsp;1&nbsp;октября конкурсанты должны были получить доступ к&nbsp;работающей платформе. Все дедлайны были привязаны к&nbsp;публичному графику конкурса и&nbsp;не&nbsp;было никакой возможности их&nbsp;сдвигать. Уже в&nbsp;июле мы&nbsp;запустили Разметчик для Специалистов. Он&nbsp;позволил начать подготовку датасетов конкурса на&nbsp;русском и&nbsp;английском языках. В&nbsp;сентябре запустили тестирование платформы с&nbsp;первыми Участниками.',
        ],
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} caseName="upgreat-complex" isMargin={false}>
                <CommonTitle>Сложности</CommonTitle>
                {upgreatComplexItems.map(({ title, texts }, idx) => (
                    <div key={idx} className="upgreat-complex__item">
                        <CommonSmallTitle className="upgreat-complex__item-title">
                            {title}
                        </CommonSmallTitle>
                        {texts.map((text, index) => (
                            <CommonSmallText key={index} className="upgreat-process__paragraph">
                                {parse(text)}
                            </CommonSmallText>
                        ))}
                    </div>
                ))}
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
